const palette1 = [ '#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51' ];

export {
  palette1
};